import { useColorModeValue } from "@chakra-ui/color-mode";

export function usePaperColor() {
  return useColorModeValue("white", "#1a202c");
}
